import * as React from "react";
import { inject, observer } from "mobx-react";
import Notification from 'react-web-notification';
import { AppProps } from "../../stores/storeContract";
import icon from '../../assets/images/Moon-xs.png';

@inject("notificationStore")
@observer
export default class BrowserNotification extends React.Component<AppProps> {

	render() {

		const { browserNotification } = this.props.notificationStore;

		if (!browserNotification) {
			return(<div></div>);
		}

		const options = {
			body: browserNotification,
			icon: icon
		}
	
		return (
			<div>
				<Notification timeout={5000} title={'MoonFinex Scanner'} options={options} />
			</div>
		);
	}
}